import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getDeviceId() {
  let id = localStorage.getItem("bsc_device");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `dev-${Math.random().toString(36).slice(2)}${Date.now()}`;
    localStorage.setItem("bsc_device", id);
  }
  return id;
}

export async function fetchProgress() {
  const { data } = await axios.get(`${API}/progress/${getDeviceId()}`);
  return data;
}

export async function completePage(pageId) {
  const { data } = await axios.post(`${API}/progress/complete`, {
    device_id: getDeviceId(),
    page_id: pageId,
  });
  return data;
}

export async function fetchGallery() {
  const { data } = await axios.get(`${API}/gallery/${getDeviceId()}`);
  return data;
}

export async function saveArtwork({ pageId, title, image }) {
  const { data } = await axios.post(`${API}/gallery`, {
    device_id: getDeviceId(),
    page_id: pageId,
    title,
    image,
  });
  return data;
}

export async function deleteArtwork(itemId) {
  await axios.delete(
    `${API}/gallery/${itemId}?device_id=${getDeviceId()}`
  );
}

export async function fetchCustomPages() {
  const { data } = await axios.get(`${API}/custom-pages/${getDeviceId()}`);
  return data;
}

export async function saveCustomPage({ title, image }) {
  const { data } = await axios.post(`${API}/custom-pages`, {
    device_id: getDeviceId(),
    title,
    image,
  });
  return data;
}

export async function deleteCustomPage(itemId) {
  await axios.delete(
    `${API}/custom-pages/${itemId}?device_id=${getDeviceId()}`
  );
}

export async function fetchPurchases() {
  const { data } = await axios.get(`${API}/purchases/${getDeviceId()}`);
  return data;
}

export async function createCheckout(lookupKey, originUrl) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    origin_url: originUrl,
    device_id: getDeviceId(),
  });
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

export async function familyCreate() {
  const { data } = await axios.post(`${API}/family/create`, {
    device_id: getDeviceId(),
  });
  return data;
}

export async function familyJoin(code) {
  const { data } = await axios.post(`${API}/family/join`, {
    device_id: getDeviceId(),
    code,
  });
  return data;
}

export async function familyInfo() {
  const { data } = await axios.get(`${API}/family/${getDeviceId()}`);
  return data;
}
